/**
 * Nome legível a partir da parte local do e-mail: `claudio.hirakawa@x.com.br` →
 * `Claudio Hirakawa`.
 *
 * Reserva para quando a API não devolveu o nome do operador no login (sessão
 * guardada antes disso, ou versão mais antiga no ar). O domínio fica fora: ele
 * não diz nada sobre a pessoa — era justamente o que fazia o avatar de iniciais
 * mostrar "CB" para `claudio.hirakawa@inteegra.com.br` (o `br` do final).
 */
export function nameFromEmail(email: string): string {
  const localPart = email.trim().split('@')[0] ?? '';

  return localPart
    .split(/[._-]+/)
    .filter(Boolean)
    .map(word => word[0]!.toUpperCase() + word.slice(1))
    .join(' ');
}

/** Nome a exibir: o que a API informou, ou a reserva derivada do e-mail. */
export function displayNameOf(person: { name?: string; email: string }): string {
  return person.name?.trim() || nameFromEmail(person.email);
}
